<!-- terms-and-conditions.component.html -->
<div class="terms-wrapper p-4">
  <div class="terms-container">
    <div class="header-section">
      <div class="header-content text-center">
        <h1 class="page-title">Terms and Conditions</h1>
      </div>
    </div>

    <div class="content-section">
      <div class="terms-content">
        <div class="section-header text-center">
          <h2 class="section-title">PART A: GENERAL TERMS AND CONDITIONS</h2>
        </div>

        <!-- Introduction -->
        <section class="terms-section">
          <p>
            This Document/Agreement is a computer-generated electronic record issued in compliance with Rule 3 of the Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021, as amended, along with the Information Technology Act, 2000. It is legally valid and does not require any physical or digital signatures.
          </p>
          
          <p>
            These Terms and Conditions ("Terms") form a binding legal agreement between you and Zenithguard ("Zenithguard," "we," "us," or "our"). These Terms, comprising Part A: General Terms and Conditions and Part B: Specific Terms and Conditions, govern your access to and use of Zenithguard's services, including payment processing, technology solutions, software, analytics, and other tools or products provided by Zenithguard, its affiliates, or partnered financial institutions ("Services"). These Services may be accessed via our website, mobile applications, software, APIs, social media, or other digital platforms ("Platform"). The terms "you," "your," or "merchant" refer to individuals or businesses, whether registered or unregistered, who use the Platform or Services. The Services offered through Zenithguard's Platform are intended solely for use within India and comply with applicable Indian regulations.
          </p>
          
          <p>
            Please read these Terms carefully before using the Platform or accessing the Services. By continuing to use the Platform or Services, you acknowledge and agree to be bound by these Terms, including our Privacy Policy and any other applicable policies. If you do not agree with these Terms, you must immediately discontinue the use of our Services. Zenithguard reserves the right to modify, update, or amend these Terms at any time by posting the revised version on the website. Any changes will take effect immediately upon publication. It is your responsibility to review these Terms periodically for updates. Your continued use of the Platform or Services after any modification signifies your acceptance of the revised Terms. If you disagree with any changes or updates, your only option is to stop using the Services immediately. Failure to do so will indicate your acceptance of the modified Terms.
          </p>

          <p>
            From time to time, Zenithguard or its Affiliates may require you to agree to additional terms for specific services you choose to avail yourself of. By accessing or using any such service via our Platform, you agree to the supplemental terms associated with that service. These terms may be available through a hyperlink on our Platform. We may request your explicit acceptance before granting access to the specific service.
          </p>

          <p>
            When registering for a specific service, you may be required to provide additional information. You consent to Zenithguard storing and using this information for your initial sign-up and future onboarding processes. Additionally, you agree that Zenithguard may pre-fill registration forms for subsequent services based on previously provided data. Zenithguard reserves the right to verify and, if necessary, re-verify any information you submit to ensure compliance with our requirements. Your ability to access or use any specific service is contingent upon completing the registration process, which remains at Zenithguard's sole discretion. If there is any inconsistency between these General Terms and the supplemental terms of a particular service, the specific service terms will take precedence. Any claims or disputes regarding a particular service must be directed solely to the Zenithguard Affiliate providing that service.
          </p>

          <p>
            Suppose you use both online and offline payment aggregation services. In that case, you acknowledge that Zenithguard will provide online services while Zenithguard POS will manage offline payment aggregation services. The terms governing these services include Part A: General Terms and Conditions and Part VII: Specific Terms for Offline Aggregation Services and Devices under Part B: Specific Terms and Conditions. For clarity, references to Zenithguard under Part A: General Terms and Conditions also apply to Zenithguard POS.
          </p>
        </section>

        <!-- Section 1: PROPRIETARY RIGHTS -->
        <section class="terms-section">
          <h3 class="section-subtitle">1. PROPRIETARY RIGHTS</h3>
          
          <div class="clause">
            <p class="clause-number">1.1</p>
            <div class="clause-content">
              <p>
                We, along with our licensors where applicable, retain full ownership of all rights, titles, and interests in the Services, including the Platform and the official website www.Zenithguard.in. This ownership extends to all associated intellectual property rights, whether registered or unregistered. We grant you a personal, non-exclusive, non-transferable, and limited right to access and use the Platform and Services strictly for personal purposes.
              </p>
              
              <p>
                We prohibit you from removing, altering, or obscuring proprietary rights notices, such as copyright or trademark, displayed on or within the Services. We reserve all rights not expressly granted under these Terms. Our exclusive property is our trademarks, trade names, service marks, logos, domain names, and other brand identifiers ("marks"). Without our written consent, you cannot use, reproduce, or distribute these marks. We do not allow downloading, copying, modifying, creating derivative works, reverse engineering, decompiling, disassembling, transmitting, or otherwise attempting to access the source code of any part of the Services. You are also prohibited from selling, assigning, sublicensing, granting security interests, or transferring any rights related to the Services or our marks.
              </p>
              
              <p>
                We may designate specific information provided within the Services as confidential. You agree not to disclose or share such confidential information without our written consent.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">1.2</p>
            <div class="clause-content">
              <p>
                We grant Zenithguard, its affiliates, and third-party service providers a royalty-free, non-exclusive, irrevocable, transferable, and sublicensable license to use your data, customer data, trademarks, logos, content, and any other materials you upload or provide on the Platform ("Your Materials"). This license enables Zenithguard to operate, enhance, and improve the Platform, deliver Services, and fulfill its obligations under the Terms.
              </p>
              
              <p>
                Without additional consent, we may also use Your Materials for marketing and promotional activities. Additionally, Zenithguard may conduct analytics on Your Materials, with the resulting reports or data being anonymized and aggregated for business purposes in compliance with applicable laws.
              </p>
              
              <p>
                You agree to indemnify and hold Zenithguard, its affiliates, and service providers harmless from any claims or losses arising from our use of Your Materials under these terms. Your continued use of the Platform signifies your acceptance of this policy.
              </p>
            </div>
          </div>
        </section>

        <!-- Section 2: USE OF WEBSITE AND SERVICES BY USERS -->
        <section class="terms-section">
          <h3 class="section-subtitle">2. USE OF WEBSITE AND SERVICES BY USERS</h3>
          
          <div class="clause">
            <p class="clause-number">2.1</p>
            <div class="clause-content">
              <p>
                You may register as a website user only if you are 18 years or older and legally capable of entering into binding contracts under applicable laws. You must protect your passwords, login credentials, and account details. Any actions taken on the Platform or Services using your login information, whether authorized or not, will be deemed your responsibility. You must ensure account confidentiality and prevent unauthorized access. Zenithguard shall not be liable for any actions, changes, or transactions made using your secure credentials on the Website.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.2</p>
            <div class="clause-content">
              <p>
                You agree to provide accurate, current, and complete information whenever the Platform requests. If any information you provided is found to be false, outdated, or incomplete, or if Zenithguard has reason to believe so, we reserve the right to suspend or terminate your account without prior notice. Additionally, Zenithguard may partially or entirely restrict or deny your access to the Platform or Services. It is your responsibility to ensure your information remains accurate and up to date at all times.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.3</p>
            <div class="clause-content">
              <p>
                By using the Services and providing your contact details, you consent to receiving updates, offers, and promotional communications from Zenithguard, its Affiliates, or third parties. These communications may be delivered through various channels, including phone calls, SMS, email, WhatsApp, other messaging platforms, or other digital and physical means. Zenithguard may contact you to assess your interest in specific products and services or to process your requests and applications. Additionally, you authorize Zenithguard, its partners, service providers, vendors, and third parties to contact you for purposes such as offering additional products or services and sharing marketing materials or promotional content via different communication methods. You acknowledge and agree that these communications may be sent to the phone number or email address you have provided. Furthermore, you explicitly waive any preferences registered under the Do Not Disturb (DND) or National Customer Preference Register (NCPR), as per the guidelines of the Telecom Regulatory Authority of India (TRAI).
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.4</p>
            <div class="clause-content">
              <p>
                You consent and authorize Zenithguard to share your information with partner banks, financial institutions, Affiliates, vendors, service providers, and other third parties as required to deliver the products and services you choose or to offer additional value-added services. You also agree to receive communications via email, phone, or SMS from Zenithguard or its partners. If you opt out of such communications in the future, your request will apply prospectively and will not affect any previously shared data with your consent.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.5</p>
            <div class="clause-content">
              <p>
                By using the Platform or accessing our Services, you acknowledge and agree that Zenithguard may display offers, promotions, and other content from its partners, affiliates, and third parties. These offers may be tailored based on the information you or your end users provide, including past interactions on our Platform or usage of our Services. Zenithguard may utilize personal and non-personal data to customize these offers, ensuring relevance and value to you and that you explicitly consent to such usage. This personalization may include analyzing preferences, interactions, and behavioral patterns. While Zenithguard strives to present relevant offers, it does not guarantee their accuracy, quality, or suitability. These offers may also be subject to additional terms and conditions. Your engagement, or that of your end users, with any promotions or offers displayed on the Platform, is entirely voluntary. Zenithguard is not responsible for any outcomes resulting from such interactions.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.6</p>
            <div class="clause-content">
              <p>
                You acknowledge and agree that Zenithguard may conduct due diligence and request necessary KYC (Know Your Customer) information when facilitating any payment or financial transaction through the Platform. As a customer or merchant, you are required to provide accurate details in compliance with Applicable Laws. Zenithguard may also undertake enhanced due diligence, including additional documentation, to meet regulatory requirements. You are solely responsible for understanding and adhering to all Applicable Laws, including but not limited to the RBI Guidelines on Regulation of Payment Aggregators and Payment Gateways, the Payment and Settlement Systems Act, 2007, the Prevention of Money Laundering Act, 2002, and relevant KYC regulations issued by the RBI, as amended from time to time. Your continued use of the Platform and Services constitutes your agreement to comply with these legal and regulatory obligations applicable to your business transactions through Zenithguard.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.7</p>
            <div class="clause-content">
              <p>
                You agree that before availing of any Service(s) under these Terms, you must provide the necessary KYC documents as determined by Zenithguard, its Facility Providers, or regulatory authorities. These documents enable Zenithguard to conduct due diligence on you and your business activities. Zenithguard reserves the right to share KYC documents or related information with Facility Providers, government authorities, or law enforcement agencies as required under Applicable Laws. You expressly consent to Zenithguard relying on the provided KYC documents to offer its services. Additionally, you acknowledge that Zenithguard may monitor, review, retain, or disclose any relevant information to comply with legal obligations, regulatory requirements, or government requests.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.8</p>
            <div class="clause-content">
              <p>
                Zenithguard shall have the right to demand from You, any (i) additional KYC Documents and /or (ii) any KYC related or other documents of Your customers or invoices, in its sole discretion and / or as per the Applicable Laws or pursuant to requests from governmental authorities, law enforcement agencies or Facility Providers. Zenithguard may suspend the Services and/or stop settlement of monies (as applicable) if you fail to submit KYC Documents when requisitioned.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.9</p>
            <div class="clause-content">
              <p>
                You acknowledge that Zenithguard is not responsible for delivery, after-sales service, payments, invoicing, collections, customer inquiries, technical support, maintenance, or other obligations related to your products or services. These responsibilities remain solely yours. You agree to indemnify Zenithguard against any claims arising from such obligations and bear all associated costs.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.10</p>
            <div class="clause-content">
              <p>
                By using the Services, you confirm that neither you, your affiliates, nor your Beneficial Owner are classified as Politically Exposed People. If this status changes at any time, you agree to notify us in writing immediately. Any capitalized terms used herein shall have the meaning assigned under RBI's KYC Guidelines, as amended periodically.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.11</p>
            <div class="clause-content">
              <p>
                To use the Platform, you may need to consent to share your Personal Information ("PI"), including any personal or sensitive data as defined under Applicable Laws. You also authorize Zenithguard to obtain your data from relevant sources, public registries, or portals as needed to complete your profile, process your application, conduct due diligence, perform KYC checks, or deliver Services. You expressly permit Zenithguard to rely on this information and confirm that all details provided will remain accurate. Zenithguard follows the industry's best data protection, privacy, and security practices while processing such information. However, Zenithguard is not liable for any claims or liabilities arising from using, processing, or sharing your PI, as such actions are undertaken only with your explicit consent.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.12</p>
            <div class="clause-content">
              <p>
                You agree not to use the Platform and/or Services for any purpose unlawful, illegal, or forbidden by these Terms or any local laws that might apply to You. At our sole discretion, we may, at any time and without advance notice or liability, suspend, terminate, or restrict Your access to all or any component of the Platform and/or Services.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.13</p>
            <div class="clause-content">
              <p>
                You are prohibited from posting or transmitting to or through this Platform: (i) unlawful, threatening, libellous, defamatory, obscene, pornographic or other material that violates rights of publicity and/or privacy, violates any law, harms minors in any way; (ii) commercial content (including, but not limited to, solicitation of funds, advertising, or marketing of any good or service); (iii) any material or content that infringes, misappropriates or violates any copyright, trademark, patent right or other proprietary right of any third party; (iv) contains software viruses, computer code, files, or programs that interfere with, destroy or limit the functionality of any computer resource; (v) threatens Indian unity, integrity, defense, security, or sovereignty, friendly relations with foreign countries, or public order or incites to commit any cognizable offence, prevents investigation of any offence, or insults any other nation; (vi) impersonates another person; or (vii) is illegal in any other way. By posting content to this Platform, you are solely responsible for any damages from violating the restrictions.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.14</p>
            <div class="clause-content">
              <p>
                You represent and warrant that:
                <br>
                (a) You are properly incorporated or established under the laws of Your jurisdiction and have all the necessary authority and power to own and operate Your business.
                <br>
                (b) You have the full legal capacity and power to enter into, exercise Your rights under, and perform Your obligations under these Terms.
                <br>
                (c) All necessary corporate and organizational actions, including but not limited to board resolutions, powers of attorney, and letters of authority to bind Your company/firm/organization, have been taken to authorize the execution, delivery and performance of these Terms.
                <br>
                (d) You have duly accepted these Terms, which form a legal, valid and binding obligation, enforceable in accordance with its clauses.
                <br>
                (e) You shall not engage in any activities related to virtual currencies, cryptocurrencies, or other crypto-based products, including non-fungible tokens (NFTs), prohibited investments for commercial gain, or credits that can be monetized, resold, or converted into physical or digital goods or services. Any violation of this provision may result in the immediate suspension or termination of your access to the Platform or Services at Zenithguard's sole discretion. You agree to indemnify Zenithguard against any losses or liabilities arising from your breach of this provision.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.15</p>
            <div class="clause-content">
              <p>
                You acknowledge, represent, and warrant that:
                <br>
                (a) Your use of the Platform and Services, as well as the sale of your products or services, is solely for legitimate business purposes. It complies with all applicable laws, regulations, and instructions issued by Zenithguard and its Facility Providers.
                <br>
                (b) The Services you use align strictly with the business categories you registered for during onboarding on the Zenithguard dashboard or as otherwise approved in writing by Zenithguard.
                <br>
                (c) You shall not resell, assign, or transfer the Services, either in whole or in part, nor permit third parties, including affiliates, to access or use them.
                <br>
                (d) You will not use the Services for unlawful, fraudulent, unauthorized, or deceptive activities that may lead to unjust enrichment or illegal financial gain.
                <br>
                (e) Your use of the Services does not promote, facilitate, or involve the sale or purchase of any prohibited products or services as outlined in these Terms.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.16</p>
            <div class="clause-content">
              <p>
                You confirm that you have obtained the explicit and informed consent of your customers to share their information, including personal data, with Zenithguard and its affiliates for the following purposes:
                <br>
                (i) Facilitating the provision of Services to you and other users of the Platform or Services.
                <br>
                (ii) Complying with requests from governmental authorities as required under applicable laws.
                <br>
                (iii) Enabling transaction monitoring, fraud prevention, and risk assessment.
                <br>
                (iv) Adhering to regulatory directives, including but not limited to orders and notices issued under Section 91 of the Code of Criminal Procedure (CrPC).
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.17</p>
            <div class="clause-content">
              <p>
                You acknowledge that the Services are highly complex and require the involvement of Facility Providers. You acknowledge and agree that Zenithguard will only be responsible for acts and omissions that are solely and directly its fault.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.18</p>
            <div class="clause-content">
              <p>
                To access the Services, you must integrate Zenithguard's solutions into your platform. Any Server-to-Server (S2S) integration, if implemented, shall be solely for the purpose of utilizing the Services and is intended for your exclusive use and access.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.19</p>
            <div class="clause-content">
              <p>
                You shall assist Zenithguard by providing necessary records, including KYC documents, transaction proofs, invoices, and other relevant data, as requested by auditors, Facility Providers, government authorities, or law enforcement agencies. These requests may occur periodically, and you must comply promptly. You must securely maintain transaction records for at least ten years from the order date on your platform. Zenithguard, its partners, and authorized agencies reserve the right to audit and inspect these records at any time without prior notice. Your full cooperation is expected in facilitating audits, inspections, or any official inquiries to ensure compliance with legal and regulatory requirements. Compliance with such requests is essential to maintaining security, transparency, and trust in all transactions.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.20</p>
            <div class="clause-content">
              <p>
                You shall not (whether online or otherwise):
                <br>
                (i) describe Yourself as an agent or representative of Zenithguard or the Facility Provider;
                <br>
                (ii) represent that You are authorized to provide any products or services offered by Zenithguard or the Facility Provider; and
                <br>
                (iii) You may make any representations or provide any warranty to Your customer or to any third party that may require Zenithguard or Facility Provider to assume, or be responsible for, any obligations or responsibilities relating to Your customer or any third party, whether directly or indirectly.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">2.21</p>
            <div class="clause-content">
              <p>
                If a customer purchases goods or services from you, you may choose, at your sole discretion, to apply a convenience fee. However, any liability or losses incurred by Zenithguard due to the imposition of such a fee shall be your responsibility. You agree to bear full responsibility for any consequences arising from these charges and shall indemnify Zenithguard against any related claims, damages, or losses.
              </p>
            </div>
          </div>
        </section>

        <!-- Continue with remaining sections 3-15 following the same pattern -->

        <!-- Section 3: PAYMENT -->
        <section class="terms-section">
          <h3 class="section-subtitle">3. PAYMENT</h3>
          
          <div class="clause">
            <p class="clause-number">3.1</p>
            <div class="clause-content">
              <p>
                Zenithguard may charge applicable fees for providing its services, which will be determined and updated at its sole discretion. You agree that these fees will be applied based on the specified rates, manner, and frequency set by Zenithguard. These charges grant access to Zenithguard's full suite of payment solutions, including the dashboard, custom reports, and applicable MDR charges as per regulatory guidelines. For clarity, Zenithguard fees include zero MDR for RuPay Debit Card and UPI transactions.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">3.2</p>
            <div class="clause-content">
              <p>
                Fees are exclusive of applicable taxes, and Zenithguard will occasionally charge such applicable taxes on the fees. You agree that you shall bear any statutory variations in applicable taxes during the subsistence of these Terms.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">3.3</p>
            <div class="clause-content">
              <p>
                We will raise monthly invoices regarding fees charged for Services provided during such a month. Invoices are available on the dashboard every month. Any dispute regarding an invoice must be communicated by You to us via notice no later than ten (10) days from the invoice date. Zenithguard shall use reasonable faith efforts to reconcile any reasonably disputed amounts.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">3.4</p>
            <div class="clause-content">
              <p>
                You shall do daily reconciliation for all the transactions processed. In case of discrepancies, You shall report to Zenithguard regarding such discrepancy within three (3) days upon the receipt of the funds. Zenithguard shall not be liable for any reconciliation issue if you highlight the same to Zenithguard after such time.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">3.5</p>
            <div class="clause-content">
              <p>
                Suppose fees are deducted upfront before the provision of a specific service, and you deposit applicable taxes under Section 194H of the Income Tax Act, 1961 (for invoices received by you). In that case, Zenithguard will reimburse the corresponding tax amount every quarter upon submission of Form 16-A as proof of payment. In all other cases, for invoices received, you must withhold applicable taxes under Section 194H at the time of fee payment (if LTDC is provided as per the issued LTDC). You are responsible for depositing the withheld taxes with the government Treasury, filing the required returns, and providing Zenithguard with Form 16-A within 180 days to ensure Zenithguard can claim full credit for the deducted taxes.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">3.5A</p>
            <div class="clause-content">
              <p>
                Suppose you operate as an e-commerce platform facilitating the sale of goods or services by a resident e-commerce participant. In that case, you are responsible for assessing and complying with the Tax Deducted at Source (TDS) requirements under Section 194O of the Income Tax Act, 1961. As an e-commerce operator, you must withhold Tax under this section, deposit it within the prescribed timelines, and fulfill all necessary compliance requirements as per the law. Zenithguard, a payment service provider, is not responsible for deducting Tax under Section 194O; this obligation rests solely with you as the e-commerce operator. For the purposes of this clause, "e-commerce operator" and "e-commerce participant" shall have the meanings defined under Section 194O of the Income Tax Act, 1961.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">3.6</p>
            <div class="clause-content">
              <p>
                You must update your GST registration number on the Zenithguard dashboard before the invoice is generated. You must submit your GST certificate as part of the KYC process. Zenithguard will issue a GST tax invoice and report transactions in GST returns based on your provided details. These returns will be filed within statutory timelines to ensure you can claim the appropriate input tax credit. Zenithguard shall not be liable for any errors, omissions, or misrepresentations you made when updating your GST number or other details. If any liability arises on Zenithguard due to incorrect information or deliberate withholding of statutory details by you, Zenithguard reserves the right to recover such amounts from you.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">3.6A</p>
            <div class="clause-content">
              <p>
                To ensure the issuance of a proper B2B tax invoice under GST law and facilitate your GST input credit, Zenithguard will record your correct GSTIN. You are responsible for periodically verifying your GSTIN and registered address in your Zenithguard account and updating any inaccuracies as needed. If your correct GSTIN is not updated in your account, you will bear full responsibility for any consequences. Zenithguard will not be obligated to revise invoices or make amendments to GST reporting due to incorrect or missing GSTIN details you provided.
              </p>
            </div>
          </div>
        </section>

        <!-- Section 4: PRIVACY POLICY -->
        <section class="terms-section">
          <h3 class="section-subtitle">4. PRIVACY POLICY</h3>
          <p>
            By using the website, you agree to the collection and use of Your information according to our 
            <a routerLink="/privacy-policy" class="link">Privacy Policy</a>.
          </p>
        </section>

        <!-- Section 5: THIRD PARTY LINKS / OFFERS -->
        <section class="terms-section">
          <h3 class="section-subtitle">5. THIRD PARTY LINKS / OFFERS</h3>
          <p>
            The platform may include links to third-party websites over which Zenithguard has no control. We recommend reviewing the terms and privacy policies of these websites to understand how they collect, use, and share your information. Zenithguard is not responsible for the terms, policies, or practices of any external websites linked to our platform. You acknowledge and agree that Zenithguard bears no responsibility for any loss or damage arising from your use of or reliance on the content, goods, or services available through such third-party sites. Your interactions with external websites are at your own risk. Zenithguard holds no liability for any actions, errors, warranties, omissions, or damages, including personal injury, property damage, or other expenses resulting from such interactions.
          </p>
        </section>

        <!-- Section 6: DISCLAIMER OF WARRANTY -->
        <section class="terms-section">
          <h3 class="section-subtitle">6. DISCLAIMER OF WARRANTY</h3>
          <p>
            To the fullest extent permitted by applicable laws, the Platform and Services are provided on an "as is" basis. You acknowledge that Zenithguard makes no guarantees that the Services will be uninterrupted, error-free, or specifically suited to meet your business needs.
          </p>
        </section>

        <!-- Section 7: LIMITATION OF LIABILITY -->
        <section class="terms-section">
          <h3 class="section-subtitle">7. LIMITATION OF LIABILITY</h3>
          
          <div class="clause">
            <p class="clause-number">7.1</p>
            <div class="clause-content">
              <p>
                Zenithguard, including its officers, directors, employees, representatives, affiliates, and service providers, shall not be held responsible or liable for any injury, death, loss, claim, accident, delay, act of God, or any direct, indirect, incidental, special, punitive, exemplary, or consequential damages (including but not limited to lost profits or savings). This applies regardless of whether such liability arises from contract, tort, strict liability, or otherwise and is in connection with (i) any failure or delay, including the inability to use any part of the Platform, (ii) the use of the Platform, Services, or content, (iii) performance or non-performance by Zenithguard or any Facility Provider, even if advised of potential damages, or (iv) any viruses or harm to your devices resulting from accessing the Platform or Services.
              </p>
            </div>
          </div>

          <div class="clause">
            <p class="clause-number">7.2</p>
            <div class="clause-content">
              <p>
                Zenithguard's total liability, including its affiliates, officers, employees, and agents, for any claims related to the Services shall not exceed the amount equivalent to one (1) month of fees paid by you for the specific Service in question. Furthermore, Zenithguard's liability shall be proportionally reduced if any loss or damage is caused or contributed to by you or your third-party service providers.
              </p>
            </div>
          </div>
        </section>

        <!-- Section 8: INDEMNITY -->
<section class="terms-section">
  <h3 class="section-subtitle">8. INDEMNITY</h3>
  <p>
    You agree to indemnify and hold Zenithguard, along with its officers,
    affiliates, group companies, directors, agents, and employees,
    harmless from all claims, whether brought by third parties or not, as
    well as any causes of action, demands, losses, damages, fines,
    penalties, or expenses, including reasonable legal fees. This
    indemnification applies to any claims arising from your breach of
    these Terms, violation of applicable laws or third-party rights, or
    your use of the Platform. Additionally, it covers any disputes between
    you and third parties. The indemnity obligations outlined herein shall
    survive and remain in effect even after you cease using the Services.
  </p>
</section>

<!-- Section 9: CARD ASSOCIATION RULES -->
<section class="terms-section">
  <h3 class="section-subtitle">9. CARD ASSOCIATION RULES</h3>
  
  <div class="clause">
    <p class="clause-number">9.1</p>
    <div class="clause-content">
      <p>
        "Card Payment Network Rules" encompass the written regulations,
        guidelines, processes, interpretations, and other contractual or
        otherwise requirements established by card payment networks. These
        networks provide the necessary infrastructure and systems for
        transaction authorization. You must comply with all applicable rules,
        guidelines, and regulations set by the card payment networks.
      </p>
    </div>
  </div>

  <div class="clause">
    <p class="clause-number">9.2</p>
    <div class="clause-content">
      <p>
        Card payment networks can update their guidelines, rules, and
        regulations periodically. As a result, we may need to modify these
        Terms to align with such changes. Any amendments made in compliance
        with updated Card Payment Network Rules will take effect immediately
        and be binding on you.
      </p>
    </div>
  </div>

  <div class="clause">
    <p class="clause-number">9.3</p>
    <div class="clause-content">
      <p>
        You agree to fully comply with all programs, guidelines, and
        requirements issued or mandated by card payment networks. While
        Zenithguard may assist in understanding these rules, you acknowledge and
        accept full responsibility for ensuring compliance with all Card
        Payment Network Rules provisions, regardless of your awareness of or
        access to them. For reference, card networks such as MasterCard, Visa,
        Diners, RuPay, and American Express provide excerpts of their
        respective rules on their official websites.
      </p>
    </div>
  </div>

  <div class="clause">
    <p class="clause-number">9.4</p>
    <div class="clause-content">
      <p>
        Suppose your non-compliance with Card Payment Network Rules
        results in fines, penalties, or any other charges imposed on or
        demanded from Zenithguard by a card payment network. In that case, you
        agree to promptly reimburse Zenithguard for the full fines, penalties, or
        related expenses incurred. This is without prejudice to any other
        rights Zenithguard may have under these Terms. Failure to fulfill your
        obligations towards the card payment networks may also lead to Zenithguard
        suspending settlements or immediately suspending or terminating the
        Services.
      </p>
    </div>
  </div>
</section>

<!-- Section 10: WAIVER -->
<section class="terms-section">
  <h3 class="section-subtitle">10. WAIVER</h3>
  <p>
    Zenithguard shall not be considered to have waived any right or provision
    of this Agreement unless such waiver is made in writing. Any waiver of
    any term or condition of this Agreement shall not apply to any other
    term or condition, nor shall it be considered as a continuing waiver.
  </p>
</section>

<!-- Section 11: FORCE MAJEURE -->
<section class="terms-section">
  <h3 class="section-subtitle">11. FORCE MAJEURE</h3>
  <p>
    Suppose Zenithguard's performance of Services or operation of the Platform
    is prevented, restricted, delayed, or disrupted due to factors beyond
    its reasonable control, including but not limited to labor disputes,
    strikes, natural disasters, epidemics, pandemics, severe weather
    conditions, material shortages, cyber threats such as viruses,
    malware, or hacking incidents, utility or communication failures, war,
    terrorism, civil unrest, government actions, regulatory mandates,
    judicial orders, or any other unforeseen events. In that case, Zenithguard
    shall be exempt from its obligations to the extent and duration of
    such force majeure event. In such cases, Zenithguard's non-performance
    shall not be considered a breach of this Agreement nor result in any
    legal liability.
  </p>
</section>

<!-- Section 12: ANTI BRIBERY AND SANCTIONS LAWS -->
<section class="terms-section">
  <h3 class="section-subtitle">12. ANTI BRIBERY AND SANCTIONS LAWS</h3>
  <p>
    You agree to conform to all applicable anti-bribery and
    anti-corruption laws, which prohibit officials, representatives,
    agents, or any individuals associated with or acting on your behalf
    from offering, promising, giving, receiving, or accepting payments,
    gifts, hospitality, or anything of value—whether directly or
    indirectly, domestically or internationally—to government officials,
    public servants, regulatory bodies, judicial authorities, persons in
    positions of authority, electoral candidates, political parties or
    their representatives, or any third party, with the intent of securing
    an improper commercial or business advantage. Government officials
    include any government employee, candidate for public office, employee
    of government-owned or government-controlled entities, public
    international organizations, and political parties. You also agree not
    to offer, pay, promise, or authorize, either directly or indirectly
    through any third party, anything of value to influence or reward
    favorable actions or decisions made on your behalf.
  </p>
</section>

<!-- Section 13: ADDITIONAL TERMS -->
<section class="terms-section">
  <h3 class="section-subtitle">13. ADDITIONAL TERMS</h3>
  
  <div class="clause">
    <p class="clause-number">13.1</p>
    <div class="clause-content">
      <p>
        You may not assign or transfer your rights or obligations under
        these Terms to any other party. Zenithguard reserves the right to assign
        its rights and obligations under these Terms without such assignment
        being considered a modification of the Terms and without providing
        notice to you. If we choose not to act on a breach of these Terms by
        you or anyone else on any occasion, this does not constitute a waiver
        of our right to take action against future or similar breaches.
      </p>
    </div>
  </div>

  <div class="clause">
    <p class="clause-number">13.2</p>
    <div class="clause-content">
      <p>
        If Zenithguard deems it necessary to reduce fraud and risk, it may
        blacklist your end users at its discretion and according to Applicable
        Laws. The blacklisted users may face transaction restrictions, and
        their removal may be subject to updated risk assessments. You
        acknowledge and agree that Zenithguard may implement measures to protect
        the integrity of the payment ecosystem. Zenithguard is not required to
        provide prior notice or a justification for these actions. You agree
        that you are responsible for notifying your end users of such
        restrictions.
      </p>
    </div>
  </div>

  <div class="clause">
    <p class="clause-number">13.3</p>
    <div class="clause-content">
      <p>
        The following additional terms apply to Zenithguard or its
        Affiliates' Services:
        <br> (a). These Terms shall be governed by the laws of India,
        without consideration of any conflict of law principles. You agree
        that any legal proceedings related to your use of the Platform or
        these Terms will be filed exclusively in the courts of India. In the
        event of any legal action initiated by either party, the prevailing
        party will recover all associated judicial costs, including taxable
        and non-taxable expenses and reasonable attorney fees. By using the
        Platform, you confirm that you have read, understood, and agreed to
        these Terms, which carry the same legal weight as a signed agreement.
        This clause will remain in effect even after the termination of these
        Terms.
        <br>
        (b). Without limiting any other rights or remedies available to
        Zenithguard, you agree and acknowledge that Zenithguard reserves the right to
        set off, by any means necessary, any portion or the entirety of your
        outstanding liabilities under these Terms (or any other agreement
        between you and Zenithguard or its affiliates) against any funds,
        payments, or amounts credited to you or owed to you under these Terms
        (or any related agreement). Zenithguard may exercise this right of set-off
        at its sole discretion and without prior notice. If the set-off amount
        does not fully cover the liability owed, you agree to pay Zenithguard any
        remaining balance to cover the shortfall promptly.
        <br>
        (c). You shall not, whether online or offline:
        <br> (i) Present yourself as an agent or representative of Zenithguard
        or any Facility Provider.
        <br> (ii) Claim the authority to offer products or services on
        behalf of Zenithguard or any Facility Provider.
        <br> (iii) Make any statements, warranties, or commitments to your
        customers or third parties that could impose any direct or indirect
        obligation or liability on Zenithguard or any Facility Provider.
        <br> Additionally, Zenithguard reserves the right to modify its website,
        policies, agreements, these Terms, and the Privacy Policy at any time
        as deemed necessary. Such changes may be made to comply with legal or
        regulatory updates, correct errors or ambiguities, reflect changes in
        services or business operations, align with industry practices, or
        address customer needs.
      </p>
    </div>
  </div>

  <div class="clause">
    <p class="clause-number">13.4</p>
    <div class="clause-content">
      <p>
        You agree that the fees for any Services provided under these
        Terms will be charged based on the rates, methods, and frequency
        established by Zenithguard. Zenithguard reserves the right to revise these
        fees at its discretion, including introducing charges for Services
        previously offered free of cost by this clause. You also acknowledge
        and agree that you will be responsible for paying any additional fees
        determined by Zenithguard in the following circumstances:
        <br>
        (a) You choose to use certain value-added services available on the
        dashboard, regardless of whether they were previously offered free of
        charge.
        <br>
        (b) You access any new Services not specified in these Terms.
        <br>
        By using any Service or value-added service, you acknowledge and
        consent to any additional fees that Zenithguard may impose for such
        Services or features.
      </p>
    </div>
  </div>

  <div class="clause">
    <p class="clause-number">13.5</p>
    <div class="clause-content">
      <p>
        End users may access dynamic currency conversion ("DCC")
        services provided by Zenithguard, where applicable. The total transaction
        amount payable by the end user for purchasing goods or services from a
        merchant will include any charges associated with the DCC services
        used. To request invoices for DCC transactions, end users can contact
        <a href="mailto:support@Zenithguard.in" class="link">support@Zenithguard.in</a> and
        provide the payment ID and their contact number.
      </p>
    </div>
  </div>
</section>

<!-- Section 14: ADVERTISING -->
<section class="terms-section">
  <h3 class="section-subtitle">14. ADVERTISING</h3>
  <p>
    Certain Services may be supported by advertising revenue and may
    feature advertisements or promotional content. These advertisements
    may be customized based on stored information, user queries, or other
    relevant data. Zenithguard reserves the right to determine the manner,
    format, and extent of advertising, which may change at any time
    without prior notice. By accessing and using the Services, you
    acknowledge and agree that Zenithguard may display such advertisements
    across various platforms, including websites, print media, electronic
    media, social media, and advertising networks.
  </p>
</section>

<!-- Section 15: SUSPENSION AND TERMINATION -->
<section class="terms-section">
  <h3 class="section-subtitle">15. SUSPENSION AND TERMINATION</h3>
  
  <div class="clause">
    <p class="clause-number">15.1</p>
    <div class="clause-content">
      <p>
        Notwithstanding anything to the contrary in these Terms, Zenithguard
        reserves the right to immediately suspend Services and withhold any
        settlements or payments to you, without liability, under the following
        circumstances:
        <br>
        (a) You violate any provision of these Terms.
        <br>
        (b) You facilitate transactions that are unlawful or involve
        activities listed under the 'Prohibited Products and Services'
        outlined in Clause 17 of Part A: General Terms and Conditions.
        <br>
        (c) Zenithguard receives instructions from Facility Providers, government
        authorities, or law enforcement agencies to suspend Services, either
        partially or fully, regardless of whether an investigation or inquiry
        into alleged illegal activities is ongoing.
        <br>
        (d) You engage in transactions flagged as high-risk according to
        Zenithguard's internal fraud detection tools and risk assessment policies.
        <br>
        (e) Zenithguard has reasonable grounds to believe that your activities
        involve suspicious behavior.
        <br>
        (f) There are pending, anticipated, or excessive disputes,
        chargebacks, refunds, or reversals linked to your use of the Services.
        <br> (g) Your products or services infringe, or are suspected of
        infringing, intellectual property rights, including copyrighted works,
        patents, trademarks, and trade secrets, or you are suspected of
        dealing in counterfeit or unauthorized goods.
        <br> (h) You make significant changes to your products or services,
        as initially declared during onboarding, without Zenithguard's prior
        written approval, or you provide false or misleading information
        regarding your offerings during onboarding.
        <br> (i) Zenithguard, at its sole discretion, determines that your
        activities pose unacceptable risks to its operations or reputation.
        <br> (j) Zenithguard is compelled to suspend services due to changes in
        regulations or compliance requirements affecting the Services.
      </p>
    </div>
  </div>

  <div class="clause">
    <p class="clause-number">15.2</p>
    <div class="clause-content">
      <p>
        These Terms become effective when you first access or use the
        Platform or Services and will remain in force until you or Zenithguard
        terminates such access or usage. Unless you have a separate offline
        agreement governing your use of the Services, these Terms will apply
        in full. Zenithguard reserves the right to terminate these Terms or close
        your account at any time, for any reason, including but not limited to
        activities that could damage Zenithguard's reputation or goodwill. If
        applicable laws require prior notice before termination, Zenithguard will
        provide you with the necessary advance notice following those legal
        requirements.
      </p>
    </div>
  </div>

  <div class="clause">
    <p class="clause-number">15.3</p>
    <div class="clause-content">
      <p>
        Termination of these Terms does not immediately release you from
        any obligations incurred before termination. Upon termination, you
        agree to cease using the Services. If you continue or resume using the
        Services after termination, it will be considered as your renewed
        acceptance of these Terms. Additionally, you acknowledge and agree
        that Zenithguard will not be responsible for any compensation,
        reimbursement, or damages arising from your use of the Services, the
        termination or suspension of Services, or the deletion of your account
        or related data. You will remain responsible for any outstanding fees,
        fines, or other financial obligations incurred through your use of the
        Services before termination.
      </p>
    </div>
  </div>
</section>
      </div>
    </div>
  </div>
</div>